/**
 * React Query 全局配置
 * 门店场景的取舍写在下面每一项的注释里。
 */
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/http';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 收银台数据变化快，但 30 秒内重复进出页面不必反复请求
        staleTime: 30_000,
        // 前台会长时间开着窗口，切回来时自动取最新数据
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // 401/403 重试没有意义，只会让用户多等
          if (error instanceof ApiError && !error.isNetworkError) return false;
          // 网络抖动时重试两次，门店 WiFi 不稳定是常态
          return failureCount < 2;
        },
      },
      mutations: {
        // 写操作绝不自动重试：可能产生第二笔真实收款
        retry: false,
      },
    },
  });
}
